// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"2be56f01","239":"23873f6c","455":"e9cefbed","977":"1c6b1683"}[chunkId] + ".chunk.js";
};